import {debounce} from 'lodash'

export default {
    props: {
        value: {},
        label: {
            type: String,
            default: ''
        },
        progress: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        itemValue: {
            type: String,
            default: 'default'
        },
        itemTitle: {
            type: String,
            default: 'name'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: []
        },
        requestInterval: {
            type: Number,
            default: 700
        },
        isValid: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            openSelect: false,
            selectedItem: this.value,
        }
    },
    watch: {
        selectedItem(val) {
            this.selectedItem = val
        },
        value() {
            this.selectedItem = this.value.hasOwnProperty(this.itemTitle) ? this.value[this.itemTitle] : this.value;
        }
    },
    created() {
        this.selectedItem = this.value[this.itemTitle];
    },
    methods: {
        changeSelect(item) {
            this.selectedItem = item[this.itemTitle];
            this.$emit('input', item);
        },

        handleInput: debounce(function (event) {
            this.$emit('handle-input', event.target.value);
        }, 700),

        changeShowTooltipList(status) {
            setTimeout(() => {
                this.openSelect = status
            }, 200)
        },
        changeOpenSelect() {
            this.openSelect = !this.openSelect;
        }
    }
}
